// Generated by ts-to-zod
import { z } from 'zod';
import { rawSchemaSchema } from '../models/rawSchema.schema';
import { schemaSchema } from '../models/schema.schema';

export const patchSchemaPayloadSchema = schemaSchema.partial();

export const patchRawSchemaPayloadSchema = rawSchemaSchema.partial();
